<template>
  <div :class="$style.iconWrapper" @click="handleClick">
    <WfIcon icon="chevron-down" color="black" />
  </div>
</template>

<style lang="scss" module>
.iconWrapper {
  width: 18px;
  height: 18px;
  padding: 6px;
  border-radius: 2px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.06);
  }

  :global(svg) {
    max-width: initial;
    max-height: initial;
    transition: transform 0.2s ease-in-out;
    transform: v-bind(transform);
  }
}
</style>

<script setup>
import { computed } from 'vue';
import WfIcon from '@/components/WfIcon.vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const transform = computed(() => (props.isOpen ? 'rotate(0)' : 'rotate(-90deg)'));

const emit = defineEmits(['open']);

const handleClick = () => {
  emit('open', !props.isOpen);
};
</script>
